import { render, staticRenderFns } from "./SearchSuggestions.vue?vue&type=template&id=b7ac772c&"
import script from "./SearchSuggestions.vue?vue&type=script&lang=ts&"
export * from "./SearchSuggestions.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports